import { render, staticRenderFns } from "./Alibaba-order.vue?vue&type=template&id=890f7b34&scoped=true&"
import script from "./Alibaba-order.vue?vue&type=script&lang=js&"
export * from "./Alibaba-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f7b34",
  null
  
)

export default component.exports